import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { Wrapper } from './index.styles';

import Content from './content';
import Nav from './nav';
import WebsocketHandler from './websocket_handler';

import { maybeCurrentBusinessState } from '../../../store';

export default function DashboardPage() {
  const maybeCurrentBusiness = useAtomValue(maybeCurrentBusinessState);

  const hasPlan = !maybeCurrentBusiness || Boolean(maybeCurrentBusiness.plan_id);

  if (!hasPlan) {
    return <Navigate to="/onboarding" />;
  }

  return (
    <Wrapper>
      <Nav />
      <Content />
      <WebsocketHandler />
    </Wrapper>
  );
}
